import { render } from "./AddResultForm.vue?vue&type=template&id=22c22480"
import script from "./AddResultForm.vue?vue&type=script&lang=js"
export * from "./AddResultForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/webovi/rastemo/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__